// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2rdCI","largeContent":"styles_largeContent__Hn7qM"};